import { useEffect, useState } from "react"
import * as React from 'react';

import "./facultyScreens.css"
import axios from "axios"
import Cookies from "js-cookie"
import { resources } from "../Resourses/Resources"
import Dialog from '@mui/material/Dialog';

import List from '@mui/material/List';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import DeleteIcon from '@mui/icons-material/Delete';
import PaginationReUsable from "../ReuseableComponent/ReusePagination";
import ImageViewer from "../Login/GalleryView";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const ViewEvents = () => {
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = useState("");
    const [paginationData, setPaginationData] = useState([])
    const [allData, setAllData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [serialNo, setSerialNo] = useState("")
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const userDetailsCookie = Cookies.get("userDetails");
    const [eventsDetails, setEeventsDetails] = useState([])
    const [selectedFile, setSelectedFile] = useState("")
    const [departMent, setDepartment] = useState("")
    const [openEventView, setOpenEventView] = useState(false)
    const [eventItems,setEventItems]=useState({})
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")

    useEffect(() => {
        if (userDetailsCookie != null && userDetailsCookie != "") {
            const userDetails = JSON.parse(userDetailsCookie);
            const details = userDetails.department
            setDepartment(details)
        }
    }, [userDetailsCookie])
    console.log("department in view===>", departMent)
    const fetchEvents = async () => {
        try {
            const response = await axios.get(resources.APPLICATION_URL + `getEventsDetails?department=${departMent}`)
            console.log("response from bacend===>", response.data)
            setEeventsDetails(response.data)
            setAllData(response.data)
            setFilteredData(response.data)
            setPaginationData(response.data)
        } catch (error) {
            console.log("error")
        }
    }
    useEffect(() => {
        if (departMent != null && departMent != "") {

            fetchEvents();
        }
    }, [departMent])
    const handleViewFile = async (filePath) => {
        // setSelectedFile(filePath)
        // handleClickOpen()
        setOpenEventView(true)
setEventItems(filePath)
   

    };
    useEffect(() => {
        
    },[eventItems])
    console.log("filePath===>", selectedFile);
    const handleDelete = async (items) => {
        console.log("deletable record===>", items)
        const response = await axios.delete(resources.APPLICATION_URL + `deleteTheEventById?sno=${items.sno}`)
        console.log("response after deletig===>", response)
        if (response.status === 200) {
            alert("Sucessfully deleted the record")
            fetchEvents()
        } else {
            alert("Unable to delete the record")
        }
    }
    const handleSearch = (e) => {
        let { value } = e.target
        console.log("value", search)
        let list = allData.filter(each => each.conductedBy.toLowerCase().includes(value.toLowerCase()))
        console.log("list==>", list)
        setFilteredData(list)
        setSearch(value)
    }
    const handleGetSpliceData = (receivedList, startSNo) => {
        setPaginationData(receivedList)
        setSerialNo(startSNo);
    }
    const handleSearchByDate = async () => {
        console.log("from date===>", fromDate)
        console.log("toDate date===>", toDate)
        const details = allData.filter((items) => {
            const newDate = items.startDate;
            if(newDate >= fromDate && newDate <= toDate){
                return items;
            }
             
        })
        setFilteredData(details)
        console.log("details===>", details)

    }
    return (
        <div className="vewContainer">
          
                        <div className="searchDiv">
                <div className="fromDateToDateDiv">
                    <div className="fromDateToDateInput">
                        <label>From Date</label>
                        <input type="date" placeholder="Issued by..." value={fromDate} onChange={(e) => setFromDate(e.target.value)} />

                    </div>
                    <div className="fromDateToDateInput">
                        <label>To Date</label>
                        <input type="date" placeholder="Issued by..." value={toDate} onChange={(e) => setToDate(e.target.value)} />
                        <button onClick={() => handleSearchByDate()}> View</button>
                    </div>
                </div>
                <input type="text" placeholder="conducted by..." value={search} onChange={(e) => handleSearch(e)} />
            </div>
            <div className="tableDiv">
                <table className="tableStylings">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Conducte dBy</th>
                            <th>Event Name</th>
                            <th>Chief Guest1</th>
                            <th>Chief Guest2</th>
                            <th>Date</th>
                            <th>File View</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginationData && paginationData.length > 0 && paginationData.map((items, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{items.conductedBy}</td>
                                    <td>{items.eventName}</td>
                                    <td>{items.chiefGuest1}</td>
                                    <td>{items.chiefGuest2}</td>
                                    <td>{items.startDate}</td>
                                    <td ><button onClick={() => handleViewFile(items)} style={{color:"Green", fontWeight:"bold",border:"none",backgroundColor:"transparent"}}>View</button></td>
                                    <td><DeleteIcon onClick={() => handleDelete(items)} className="deleteFac"/></td>

                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {/* <div>
                    {filesToView.map((items, index) => {
                        return (

                            <img
                                src={`data:application/pdf;base64,${items}`}
                                className="imageStyling"

                            />
                        )
                    })}
                </div> */}
                <React.Fragment>
                    <Dialog
                        fullScreen
                        open={open}
                        onClose={handleClose}
                        TransitionComponent={Transition}
                    >
                        <AppBar sx={{ position: 'relative' }}>
                            <Toolbar>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={handleClose}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <List>
                            {selectedFile && (
                                <div className="imageDiv">
                                    <img
                                        src={`data:application/pdf;base64,${selectedFile}`}
                                        className="imageStyling"

                                    />
                                </div>
                            )}
                        </List>
                    </Dialog>
                </React.Fragment>


                <PaginationReUsable paginationData={filteredData} handleGetSpliceData={handleGetSpliceData} />


            </div>
{openEventView===true && <ImageViewer eventItems={eventItems}/>}
        </div>
    )
}
export default ViewEvents;